import axios from '@/core/axios';

import { CustomerLedger } from './customer-ledger.types';

export class CustomerLedgerService {
  get(customerId: number | string): Promise<CustomerLedger> {
    return axios.get<CustomerLedger>(`/customers/${customerId}/ledger`).then(resp => resp?.data);
  }
}

export const customerLedgerService = new CustomerLedgerService();
